import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { ReactRelayContext } from 'react-relay/legacy.js';
import serverVars from 'server-vars';
import SellerApplicationWrapper from '../sellerApplication/SellerApplicationWrapper.tsx';
import { SellerApplicationConfirmation } from '../sellerApplication/SellerApplicationConfirmation.jsx';
import { sellerApplicationRoot } from '../sellerApplication/sellerApplicationRoot.js';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import * as tracking from 'dibs-tracking';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(sellerApplicationRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    if (serverVars.get('isConfirmation')) {
        hydrateRoot(
            document.getElementById('js-root'),
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <SellerApplicationConfirmation deviceType={serverVars.get('deviceType')} />
            </IntlProvider>
        );
    } else {
        hydrateRoot(
            document.getElementById('js-root'),
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <ReactRelayContext
                    value={{
                        environment,
                        variables: snapshot.variables || {},
                    }}
                >
                    <SellerApplicationWrapper viewer={snapshot.data.viewer} />
                </ReactRelayContext>
            </IntlProvider>
        );
    }
    tracking.trackPageview();
});
